/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 8/25/20
 *
 */

import DbBaseObject from "@shared/DbBaseObject";
import BaseDocSignElement from "@/core/modules/DocSign/data/elements/BaseDocSignElement";
import DocSignSignatureElement from "@/core/modules/DocSign/data/elements/DocSignSignatureElement";
import DocSignElementType from "@/core/modules/DocSign/data/DocSignElementType";
import DocSignTextElement from "@/core/modules/DocSign/data/elements/DocSignTextElement";
import {Type} from "class-transformer";
import QwoachFile from "@shared/Drive/QwoachFile";
import DocSignDateElement from "@/core/modules/DocSign/data/elements/DocSignDateElement";

export default class DocSignPage extends DbBaseObject{

	@Type(() => BaseDocSignElement, {
		keepDiscriminatorProperty: true,
		discriminator: {
			property: "itemType",
			subTypes: [
				{ value: DocSignSignatureElement, name: DocSignElementType.SIGNATURE },
				{ value: DocSignTextElement, name: DocSignElementType.TEXT },
				{ value: DocSignDateElement, name: DocSignElementType.DATE },
			]
		}
	})
	elements: BaseDocSignElement[] = []

	@Type(() => QwoachFile)
	preview: QwoachFile = null

	originalBrowserPageWidth: number = 0
	originalBrowserPageHeight: number = 0

	pageNumber: number = null


	constructor(preview: QwoachFile = null, elements: BaseDocSignElement[] = []) {
		super();
		this.preview = preview
		this.elements = elements;
	}
}
